import AuthRequestHelper from './AuthRequestHelper'

class AiInteractionHelper {
  // Contacts
  async getContactByUserId(id){
    try{ return await AuthRequestHelper.request('get', `interaction/ai/contact/reciever/${id}`, {}) } catch(e){ console.log(e); return {} }
  }
  async getContactSentByUserId(id){
    try{ return await AuthRequestHelper.request('get', `interaction/ai/contact/sender/${id}`, {}) } catch(e){ console.log(e); return {} }
  }
  async addContact(senderId, recieverId){
    try{ return await AuthRequestHelper.request('put', `interaction/ai/contact/sender/${senderId}`, { reciever_id: recieverId, contact_state: '1' }) } catch(e){ console.log(e); return {} }
  }
  async removeContact(senderId, recieverId){
    try{ return await AuthRequestHelper.request('delete', `interaction/ai/contact/sender/${senderId}`, { reciever_id: recieverId }) } catch(e){ console.log(e); return {} }
  }

  // Hugs
  async getHugsRecievedByUserId(id){
    try{ return await AuthRequestHelper.request('get', `interaction/ai/hug/reciever/${id}`, {}) } catch(e){ console.log(e); return {} }
  }
  async getHugsSentByUserId(id){
    try{ return await AuthRequestHelper.request('get', `interaction/ai/hug/sender/${id}`, {}) } catch(e){ console.log(e); return {} }
  }
  async addHug(senderId, recieverId){
    try{ return await AuthRequestHelper.request('put', `interaction/ai/hug/sender/${senderId}`, { reciever_id: recieverId }) } catch(e){ console.log(e); return {} }
  }
  async removeHug(senderId, recieverId){
    try{ return await AuthRequestHelper.request('delete', `interaction/ai/hug/sender/${senderId}`, { reciever_id: recieverId }) } catch(e){ console.log(e); return {} }
  }

  // Support messages
  async getSupportMsgRecievedByUserId(id){
    try{ return await AuthRequestHelper.request('get', `interaction/ai/supportmsg/reciever/${id}`, {}) } catch(e){ console.log(e); return {} }
  }
  async getSupportMsgSentByUserId(id){
    try{ return await AuthRequestHelper.request('get', `interaction/ai/supportmsg/sender/${id}`, {}) } catch(e){ console.log(e); return {} }
  }
  async addSupportMsg(senderId, recieverId, message){
    try{ return await AuthRequestHelper.request('put', `interaction/ai/supportmsg/sender/${senderId}`, { reciever_id: recieverId, message }) } catch(e){ console.log(e); return {} }
  }
  async removeSupportMsg(senderId, recieverId){
    try{ return await AuthRequestHelper.request('delete', `interaction/ai/supportmsg/sender/${senderId}`, { reciever_id: recieverId }) } catch(e){ console.log(e); return {} }
  }
}

export default new AiInteractionHelper()
